export default "__VITE_ASSET__61686759__"